// extracted by mini-css-extract-plugin
export default {"root":"Ftse100BoardMemberBadge_root__8be9g"};